import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

let _client: SupabaseClient | null = null

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ 关键错误：Supabase 环境变量缺失！请检查 Vercel 后台配置。')
} else {
  _client = createClient(supabaseUrl, supabaseAnonKey)
}

// 延迟抛出异常——仅在调用方实际使用时才报错，避免模块加载阶段崩溃
export const isSupabaseAvailable = _client !== null

export function getSupabase(): SupabaseClient {
  if (!_client) {
    throw new Error('Supabase 客户端未初始化：缺少 VITE_SUPABASE_URL 或 VITE_SUPABASE_ANON_KEY 环境变量')
  }
  return _client
}
